import { convertObjectToUrlParams, jsonToUrlParams } from '@/utils';

import { AxiosProgressEvent } from 'axios';

import api, {
	TDeleteDocumentParams,
	TDeleteDocumentWithBody,
	TDocumentUploadDefineItem,
	TGetCommonDocumentParams,
	TGetDocumentByPageParams,
	TUpdateDocumentItemParams,
} from '.';

export const getCommonDocument = async (params: TGetCommonDocumentParams) =>
	await api.get('/common/document', { params });

export const getDocumentByPage = async (params: TGetDocumentByPageParams) =>
	await api.get('/common/document/documentPage', { params });

export const updateDocumentItem = async (params: TUpdateDocumentItemParams) => {
	const { id, ...restParams } = params;
	const urlParams = convertObjectToUrlParams(restParams);
	await api.post(`/common/document/update/${id}?${urlParams}`);
};

export const deleteDocuments = async (params: TDeleteDocumentParams) => {
	const urlParams = convertObjectToUrlParams(params);
	await api.post(`/common/document/delete?${urlParams}`);
};

export const deleteDocumentsWithParams = async (
	params: TDeleteDocumentWithBody
) => {
	await api.post(`/common/document/delete?${jsonToUrlParams(params)}`);
};

export const uploadDocument = async (
	data: FormData,
	onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
	signal?: AbortSignal
) => {
	await api.post<TDocumentUploadDefineItem[]>('/common/document/upload', data, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
		onUploadProgress,
		signal,
	});
};
